import React from "react";

import "./styles.css";

export default ({ children }) => (
  <div className="details-panel">{children}</div>
);
